<template>
  <Menu
    ref="menuRef"
    v-bind="$attrs"
  >
    <template #item="{ item, props }">
      <!-- eslint-disable-next-line vue/no-restricted-html-elements -- PrimeVue's own menu-item passthrough markup, not app navigation -->
      <a
        :class="props.action"
        v-bind="props.action"
      >
        <MaterialIcon
          v-if="item.icon"
          :ligature="item.icon"
          v-bind="props.icon"
        />
        <span v-bind="props.label">{{ item.label }}</span>
      </a>
    </template>
    <template
      v-for="(_, name) in $slots"
      #[name]="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </Menu>
</template>

<script lang="ts" setup>
import { Menu } from 'primevue'
import { useTemplateRef } from 'vue'

import MaterialIcon from '@/components/atoms/icons/material-icon/MaterialIcon.vue'

defineOptions({ inheritAttrs: false })

const menuRef = useTemplateRef<InstanceType<typeof Menu>>('menuRef')

defineExpose({
  toggle: (event: Event) => menuRef.value?.toggle(event),
  show: (event: Event) => menuRef.value?.show(event),
  hide: () => menuRef.value?.hide()
})
</script>
